import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

import { Typography } from "@/components/ui-v2";
import { VideoEffectTile } from "@/components/ui-v2/Tiles/VideoEffectTile/VideoEffectTile";
import type { VideoEffectParameters } from "@/types";

import { VIDEO_EFFECT_TYPE_METADATA } from "../../../constants/videoEffectsMetadata";

interface VideoEffectProps {
  effect: VideoEffectParameters;
}

export const VideoEffect: React.FC<VideoEffectProps> = (props) => {
  const { effect } = props;
  const { type, weight } = effect;
  const effectMetadata = VIDEO_EFFECT_TYPE_METADATA[type];
  const theme = useTheme();

  return (
    <Box>
      <VideoEffectTile
        src={effectMetadata?.thumbnail}
        title={effectMetadata.title}
      />
      <Box
        sx={{
          backgroundColor: theme.palette.secondary[6],
          borderRadius: "0 0 3px 3px",
          px: 1,
          textAlign: "center",
        }}
      >
        <Typography variant="caption">Weight: {weight}%</Typography>
      </Box>
    </Box>
  );
};
